export const hairPlusFaq = [
  {
    title: 'Para que serve o suplemento +hair?',
    body: 'O +hair melhora a qualidade do fio: cabelos mais fortes, brilhosos e menos quebradiços.'
  },
  {
    title: 'Como tomar o suplemento +hair?',
    body: 'Tome uma cápsula por dia, pela manhã.'
  }
]
